import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { COMMA, ENTER, SEMICOLON } from '@angular/cdk/keycodes';
import { WorkFlowService } from '../../../services/workflow.service';

const EMAILS_SEPARATOR = ';';
const EMAILS_MAX_LENGTH = 1000;
const KNOWN_ERRORS = ['email_invalid', 'notification_emails_too_long'];

@Component({
  selector: 'send-report-email',
  templateUrl: './send-report-email.component.html',
  styleUrls: ['../../../styles/components/dialog.scss', './send-report-email.component.scss']
})
export class SendReportEmailComponent {
  readonly separatorKeys = [ENTER, COMMA, SEMICOLON];
  emails: string[] = [];
  loading = true;
  saving = false;
  error: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<SendReportEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SendReportEmailData,
    private workflowService: WorkFlowService) {
    this.workflowService.getNotificationEmails(this.data.workflowId).subscribe({
      next: (emails) => {
        this.emails = emails ?? [];
        this.loading = false;
      },
      error: () => {
        this.error = 'newworkflow_error';
        this.loading = false;
      }
    });
  }

  add(event: MatChipInputEvent): void {
    const email = (event.value || '').trim();
    if (!email) return;

    if (Validators.email(new FormControl(email)) != null) {
      this.error = 'email_invalid';
      return;
    }

    if (!this.emails.some(e => e.toLowerCase() == email.toLowerCase())) {
      if ([...this.emails, email].join(EMAILS_SEPARATOR).length > EMAILS_MAX_LENGTH) {
        this.error = 'notification_emails_too_long';
        return;
      }
      this.emails.push(email);
    }

    event.chipInput.clear();
    this.error = null;
  }

  onTyping(): void {
    this.error = null;
  }

  remove(email: string): void {
    this.emails = this.emails.filter(e => e != email);
    this.error = null;
  }

  save(): void {
    this.saving = true;
    this.error = null;
    this.workflowService.saveNotificationEmails(this.data.workflowId, this.emails).subscribe({
      next: () => this.dialogRef.close(true),
      error: (err) => {
        this.saving = false;
        this.error = KNOWN_ERRORS.includes(err.error) ? err.error : 'newworkflow_error';
      }
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }
}

export interface SendReportEmailData {
  workflowId: number;
}
